module.exports = __webpack_public_path__ + "img/SES_235250006.0e50a33e.jpg";